import React from 'react'
import NotFound from "./NotFound";
import { connect } from 'react-redux'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'

function MenuRedirects(props){
   const id = props.match.params.id;
   
   if(!id || !props.dados){
       return null;
    }
    
    const {menu} = props.dados.user;
    console.log('redirec', id);

   if(id === 'cad-geral'){
        if(!menu || menu.indexOf('cad-geral-empresa') >= 0){
            return <Redirect to="/empresa" />
        }
        else if(menu.indexOf('cad-geral-usuario') >= 0){
            return <Redirect to="/usuario" />
        }
        else if(menu.indexOf('cad-geral-caixa') >= 0){
            return <Redirect to="/caixa" />
        }
   }
   else if(id === 'cad-pessoas'){
        if(!menu || menu.indexOf('cad-pessoas-cliente') >= 0){
            return <Redirect to="/cliente" />
        }
        else if(menu.indexOf('cad-pessoas-fornecedor') >= 0){
            return <Redirect to="/fornecedor" />
        }
        else if(menu.indexOf('cad-pessoas-vendedor') >= 0){
            return <Redirect to="/vendedor" />
        }
    }
    else if(id === 'est-mov'){
        if(!menu || menu.indexOf('est-mov-lan') >= 0){
            return <Redirect to="/estoque/lan" />
        }
        else if(menu.indexOf('est-mov-compras') >= 0){
            return <Redirect to="/compras/entrada" />
        }
        else if(menu.indexOf('est-mov-entradasper') >= 0){
            return <Redirect to="/compras/periodo" />
        }
        else if(menu.indexOf('est-mov-inv') >= 0){
            return <Redirect to="/estoque/inv" />
        }
    }
    else if(id === 'fin'){
        if(!menu || menu.indexOf('fin-cp') >= 0){
            return <Redirect to="/fin/cp" />
        }
        else if(menu.indexOf('fin-cr') >= 0){
            return <Redirect to="/fin/cp" />
        }       
    }

   return <NotFound />;
}

const mapStateToProps = (state) => {
    return { dados: state.dados  };
  };
  
export default connect(mapStateToProps, { })(MenuRedirects);